// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnauthorizedPageLayout-module__pageContainer__Sf2wj {
  background: #4720c3;
  min-height: 100vh;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.UnauthorizedPageLayout-module__logo__aVCmO {
  margin-top: 28px;
}
.UnauthorizedPageLayout-module__backgroundImage1__iWquE {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  max-width: 100%;
  width: 100%;
  opacity: 0.1;
  pointer-events: none;
}
.UnauthorizedPageLayout-module__backgroundImage2__Z33Qn {
  position: absolute;
  top: 16%;
  left: -40%;
  z-index: -1;
  max-width: 100%;
  width: 100%;
  opacity: 0.1;
  rotate: 180deg;
  pointer-events: none;
}
.UnauthorizedPageLayout-module__titleContainer__q8D7m {
  position: absolute;
  width: 437px;
  bottom: 15%;
}
.UnauthorizedPageLayout-module__title__KQpP_ {
  color: #fff !important;
  font-family: Readex Pro;
  font-size: 30px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal;
}
.UnauthorizedPageLayout-module__subTitle__yDNoV {
  color: #fff;
  font-family: Nunito;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  /* 155.556% */
  letter-spacing: 0.36px;
}
.UnauthorizedPageLayout-module__rightContainer__G0ao2 {
  background: #fff;
  border-radius: 35px;
  padding: 20px;
  margin: 0 auto;
  max-width: 680px;
  width: 100%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  height: calc(100vh - 64px);
  margin-top: 28px;
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .UnauthorizedPageLayout-module__rightContainer__G0ao2 {
    height: auto;
    margin-top: 20px;
  }
  .UnauthorizedPageLayout-module__titleContainer__q8D7m {
    position: relative;
    width: 100%;
    bottom: 0;
    margin-top: 50px;
    margin-bottom: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/unauthorizedPageLayout/UnauthorizedPageLayout.module.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AACF;AACA;EACE,gBAAA;AACF;AACA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AACF;AACA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AACF;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAAF;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,mBAAA;AAAF;AAGA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EADA,aAAa;EAEb,sBAAA;AAAF;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,uCAAA;EACA,kBAAA;EACA,UAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AADF;AAMA;EACE;IACE,YAAA;IACA,gBAAA;EAJF;EAMA;IACE,kBAAA;IACA,WAAA;IACA,SAAA;IACA,gBAAA;IACA,mBAAA;EAJF;AACF","sourcesContent":[".pageContainer {\n  background: #4720c3;\n  min-height: 100vh;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n.logo {\n  margin-top: 28px;\n}\n.backgroundImage1 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  max-width: 100%;\n  width: 100%;\n  opacity: 0.1;\n  pointer-events: none;\n}\n.backgroundImage2 {\n  position: absolute;\n  top: 16%;\n  left: -40%;\n  z-index: -1;\n  max-width: 100%;\n  width: 100%;\n  opacity: 0.1;\n  rotate: 180deg;\n  pointer-events: none;\n}\n\n.titleContainer {\n  position: absolute;\n  width: 437px;\n  bottom: 15%;\n}\n.title {\n  color: #fff !important;\n  font-family: Readex Pro;\n  font-size: 30px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: normal;\n}\n\n.subTitle {\n  color: #fff;\n  font-family: Nunito;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px; /* 155.556% */\n  letter-spacing: 0.36px;\n}\n\n.rightContainer {\n  background: #fff;\n  border-radius: 35px;\n  padding: 20px;\n  margin: 0 auto;\n  max-width: 680px;\n  width: 100%;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 1;\n  height: calc(100vh - 64px);\n  margin-top: 28px;\n  display: flex;\n  align-items: center;\n}\n\n// add media query for less than md size\n\n@media (max-width: 768px) {\n  .rightContainer {\n    height: auto;\n    margin-top: 20px;\n  }\n  .titleContainer {\n    position: relative;\n    width: 100%;\n    bottom: 0;\n    margin-top: 50px;\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `UnauthorizedPageLayout-module__pageContainer__Sf2wj`,
	"logo": `UnauthorizedPageLayout-module__logo__aVCmO`,
	"backgroundImage1": `UnauthorizedPageLayout-module__backgroundImage1__iWquE`,
	"backgroundImage2": `UnauthorizedPageLayout-module__backgroundImage2__Z33Qn`,
	"titleContainer": `UnauthorizedPageLayout-module__titleContainer__q8D7m`,
	"title": `UnauthorizedPageLayout-module__title__KQpP_`,
	"subTitle": `UnauthorizedPageLayout-module__subTitle__yDNoV`,
	"rightContainer": `UnauthorizedPageLayout-module__rightContainer__G0ao2`
};
export default ___CSS_LOADER_EXPORT___;
